module.exports = __webpack_public_path__ + "img/what_we_offer.2590db3a.jpg";